(() => {
  if (window.tycerCartPreviewStarted) return;
  window.tycerCartPreviewStarted = true;
  function loadPreviews() {
    document.querySelectorAll('[data-tycer-cart-preview]:not([data-tycer-preview-loading])').forEach((holder) => {
      holder.dataset.tycerPreviewLoading = 'true';
      const image = new Image();
      image.className = 'cart-item__image';
      image.alt = 'Your approved coaster artwork';
      image.width = 150;
      image.decoding = 'async';
      image.referrerPolicy = 'no-referrer';
      image.onload = () => {
        image.height = Math.round(150 * image.naturalHeight / image.naturalWidth);
        holder.replaceChildren(image);
        holder.dataset.tycerPreviewLoaded = 'true';
      };
      // Keep the normal featured image if the derivative is unavailable.
      image.onerror = () => { holder.dataset.tycerPreviewLoaded = 'fallback'; };
      image.src = holder.dataset.tycerCartPreview;
    });
  }
  loadPreviews();
  new MutationObserver(loadPreviews).observe(document.body, { childList: true, subtree: true });
})();
